<script setup lang="ts">
    import { computed, ref } from "vue";
    import KFormFieldDisplay from "@/components/forms/displays/FormFieldDisplay/KFormFieldDisplay.vue";
    import { Listener } from "@/components/forms/Form/types";
    import { Option } from "@/components/forms/inputs/Autocomplete/types";

    defineExpose({
        formListeners: [
            {
                fieldNames: ["digitum"],
                runAtInitial: true,
                action: ({ values }: { values: { digitum: { id: string }[] } }) => {
                    digitum.value = values.digitum;
                },
            },
        ] as Array<Listener>,
    });

    const digitum = ref<{ id: string }[]>([]);

    const antal = computed(() => {
        if (digitum.value) {
            return `${
                digitum.value.filter((d) => {
                    // Vid inläsning är id ett Option-objekt.
                    // Returnerar true om värdet är ett annat tal än 0 (Ej aktuellt).

                    if (typeof d.id === "object") {
                        return Number((d.id as Option)?.value);
                    }

                    return Number(d.id);
                }).length
            }`;
        } else {
            return "-";
        }
    });
</script>

<template>
    <KFormFieldDisplay name="antal_digitum" label="Antal digitum/digitus" :value="antal" :showEmptyValue="true" />
</template>

<style lang="scss" scoped></style>
